import styles from './styles.module.css';
import UnlinkIcon from '@/assets/icons/unlink.svg?react';
import { DataTableColumn } from '@/components/DataTable';
import { Button } from '@/components/Form/Button';

export const getCompaniesColumns = <T extends { name: string }>(
  showActions: boolean = true,

  onActionClick?: (item: T) => void
): DataTableColumn<T>[] => {
  const baseColumns: DataTableColumn<T>[] = [
    {
      field: 'name',
      headerName: 'NAME',
      width: showActions ? '84%' : '100%',
      sortable: true,
      alignLeft: true,
      renderCell: ({ row }) => (
        <div className={styles.locationNameContainer}>{row.name}</div>
      )
    },
    {
      headerName: 'ACTIONS',
      width: '16%',
      renderCell: ({ row }) => (
        <Button
          label="UNASSIGN"
          icon={UnlinkIcon}
          iconPosition="right"
          onClick={() => onActionClick?.(row)}
          color="blue"
          solid={false}
          size="small"
          className={styles.unassignButton}
        />
      )
    }
  ];

  if (showActions) {
    return baseColumns;
  } else {
    return baseColumns.filter(column => column.headerName !== 'ACTIONS');
  }
};
